.uic-breadcrumb-item {
    --uic-icon-width: var(--uic-icon-dimensions-default);
    --uic-icon-height: var(--uic-icon-dimensions-default);
    @include font(small);
    display: inline-flex;
    align-items: center;
    color: var(--uic-color-black);

    > uic-icon {
        color: var(--uic-color-grey6);
    }

    &__icon {
        padding-right: 4px;
    }

    &__dots {
        display: none;
    }

    &__label {
        @include truncate();
        padding-right: 8px;
    }

    &--selected {
        font-weight: var(--uic-font-weight-semibold);

        > uic-icon {
            color: var(--uic-color-grey3);
        }
    }

    &--ellipsis {
        .uic-breadcrumb-item__dots {
            display: inline;
        }

        .uic-breadcrumb-item__icon,
        .uic-breadcrumb-item__label {
            display: none;
        }
    }
}
